export const MESSAGE_MAX_LENGTH = 512;
export const messageValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('messages.validation.message-empty');
    } else if (input.length > MESSAGE_MAX_LENGTH) {
        err = t('messages.validation.message-too-long', { maxLength: MESSAGE_MAX_LENGTH });
    }
    return err;
};
